/**
 * SAMBA configuration API schemas
 */

import { z } from 'zod';
import { PositiveIntSchema } from './common.schemas';
import {
    MerchantConfigSchema,
    UserRoleAssignmentConfigPatchSchema,
} from '../backend_config.types';
import type { PatchActiveRoleAssignmentUserRoleAssignmentConfigRequest } from '../samba-config.types';

/**
 * Config response (single config object)
 */
export const ConfigResponseSchema = MerchantConfigSchema;

/**
 * Update config request
 */
export const UpdateConfigRequestSchema = z.object({
    config: MerchantConfigSchema,
});

export const PatchActiveRoleAssignmentUserRoleAssignmentConfigRequestSchema:
    z.ZodType<PatchActiveRoleAssignmentUserRoleAssignmentConfigRequest> = z.object({
    userRoleAssignmentConfig: UserRoleAssignmentConfigPatchSchema,
});

/**
 * Update config response
 */
export const UpdateConfigResponseSchema = MerchantConfigSchema;

/**
 * Combined config response
 */
export const CombinedConfigResponseSchema = z.object({
    user_config: ConfigResponseSchema,
    org_config: ConfigResponseSchema,
});

/**
 * Role assignment config response
 */
export const RoleAssignmentConfigResponseSchema = z.object({
    role_assignment_id: z.number(),
    user_config: MerchantConfigSchema,
});

/**
 * Get effective config response
 */
export const GetEffectiveConfigResponseSchema = z.object({
    config: MerchantConfigSchema,
    version: z.string(),
});

/**
 * Common param schemas
 */
export const AuditIdParamSchema: z.ZodType<number> = PositiveIntSchema;
export const SessionUuidParamSchema: z.ZodType<string> = z.string().uuid();
export const RoleAssignmentUuidParamSchema: z.ZodType<string> = z.string().uuid();
